/* eslint func-names: ["error", "never"] */

import '~/js/sections/weddings/includes/stickyNav';
import '~/js/libs/jqueryEventMove';
import '~/js/libs/jqueryTwentytwenty';
import '~/js/sections/weddings/includes/scroll-below';

import LoginPanel from '~/js/components/wedding-styler/dashboard/LoginPanel';

const cdnURL = '//cdn.sandals.com/sandals/v12';
const box = document.querySelector('#freeWeddingandCustomize .floatingBox');
const boxContainer = document.getElementById('freeWeddingandCustomize');
const { countries, isAuthenticated }  = beaches_app.page;

ReactDOM.render(
  <LoginPanel countries={countries} isAuthenticated={isAuthenticated} />,
  document.getElementById('dashboard-modal')
);

const preventMultiple = () => {
  let popup = document.querySelectorAll('.ntf-box');

  if(popup.length > 0) {
    popup = document.querySelector('.ntf-box');
    popup.parentNode.removeChild(popup);
  }

  const targetNode = document.querySelector('body');
  const observer = new MutationObserver((mutationsList) => {
    if (!mutationsList[0].target.classList.contains('has-modal')) {
      const popupBox = document.querySelector('.ntf-box');

      popupBox === null ? '' : popupBox.parentNode.removeChild(popupBox);
    }
  });

  observer.observe(targetNode, {attributes: true});
};

document.addEventListener('click', (e) => {
  const target = e.target;

  if (target.classList.contains('form-submit-button')) {
    preventMultiple();
  }
});

const dreamItSlider = () => {

  $('.dream-it-slider').twentytwenty({
    default_offset_pct: 1,
    no_overlay: true
  }).promise().done(() => {
    $('.dream-it-caption').find('big').text('1/' + $('.dream-it-slider').length);
    $('.dream-it-slider').each(() => {
      $('.dream-it-dots').append('<span></span>');
    }).promise().done(() => {
      $('.dream-it-dots span:first').addClass('active');
    });
  });

  $(window).scroll(() => {
    const triggerPos = $('.dream-it-trigger').offset().top - $(window).scrollTop();
    const windowHeight = $(window).height();
    const itsTime = Math.round(triggerPos / windowHeight * 100) / 100;

    if (itsTime <= 0.5) {
      $(window).trigger('pullTheTrigger');
    }
  });

  $(window).one('pullTheTrigger', () => {
    $('.dream-it-slider').trigger('slidein', 80).promise().then(() => {
      const revealThis = () => {
        $('.twentytwenty-reveal').addClass('revealed');
      };

      setTimeout(revealThis, 2000);
    }).then(() => {
      $('.twentytwenty-handle').on('mousedown touchstart', () => {
        $('.twentytwenty-reveal').fadeOut('fast');
      });
    });
  });


  let dreamItCounter = 1;

  const inspirationSlider = {
    'inspirations': [{
      'inspirationTitle': ' Signature Statement Reception'
    }, {
      'inspirationTitle': ' Modern Love Reception'
    }, {
      'inspirationTitle': ' White Romance Reception'
    }, {
      'inspirationTitle': ' Island Chic Reception'
    }]
  };

  if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Edge|MSIE \d|Trident.*rv:/i.test(navigator.userAgent)) {
    let currentTime = 0;
    const videoHide = document.querySelector('.videoHide');
    const sceneContainer = document.createElement('div');
    const textWrap = document.querySelector('.weddings-top__text-wrap');
    const videoWrap = document.createElement('div');
    const button = document.querySelector('.weddings-top__btn');
    const customWeddings = document.querySelector('.customizable-weddings');

    sceneContainer.innerHTML = `
        <!--<div class="scenes" id="scene1">
            <h4>Inspired by <span>Love.</span></h4>
        </div>
        <div class="scenes" id="scene2">
            <h4>Created by <span>You.</span></h4>
        </div>
        <div class="scenes" id="scene3">
            <h4>Only At</h4><i class="icon-new-logo-beaches"></i>
        </div>
        <div class="scenes" id="scene4">
            <h4>Find Your <span>Inspiration.</span></h4>
        </div>
        <div class="scenes" id="scene5">
            <h4>Create the Wedding of</h4>
            <br>
            <h4><span>Your Dreams</span></h4>
        </div>-->`;

    videoWrap.innerHTML = `
        <video class="wedding-vid object-fit" preload="auto" autoplay loop muted volume="0">
            <source src="${cdnURL}/images/weddings/weddings/sandals-wedding-header.webm" type="video/webm">
            <source src="${cdnURL}/images/weddings/weddings/sandals-wedding-header.mp4" type="video/mp4">
            <source src="${cdnURL}/images/weddings/weddings/sandals-wedding-header.ogv" type="video/ogg ogv">
        </video>
        `;


    setTimeout( () => {
      sceneContainer.classList.add('sceneText', 'container');
      videoWrap.classList.add('wedding-vid', 'object-fit');
      button.classList.add('videoMode');
      videoHide.classList.add('videoMode');
      customWeddings.classList.add('videoMode');
    }, 4500);

    setTimeout(() => {
      textWrap.classList.add('videoMode');
    }, 4950);

    $(textWrap).parent().append(sceneContainer);
    $('.weddings-top__image-wrap').append(videoWrap);

    const headerVideo = document.querySelector('video.wedding-vid');

    const sceneChanger = () => {
      currentTime = headerVideo.currentTime;
      if (currentTime >= 0.1 && currentTime <= 4) {
        if (!$('#scene1').hasClass('active')) {
          $('#scene1').addClass('active');
        }
        $('.scenes').not('#scene1').removeClass('active');
      } else if (currentTime >= 5 && currentTime <= 8.5) {
        if (!$('#scene2').hasClass('active')) {
          $('#scene2').addClass('active');
        }
        $('.scenes').not('#scene2').removeClass('active');
      } else if (currentTime >= 9 && currentTime <= 13.5) {
        if (!$('#scene3').hasClass('active')) {
          $('#scene3').addClass('active');
        }
        $('.scenes').not('#scene3').removeClass('active');
      } else if (currentTime >= 14 && currentTime <= 23.5) {
        if (!$('#scene4').hasClass('active')) {
          $('#scene4').addClass('active');
        }
        $('.scenes').not('#scene4').removeClass('active');
      } else if (currentTime >= 24 && currentTime <= 29.5) {
        if (!$('#scene5').hasClass('active')) {
          $('#scene5').addClass('active');
        }
        $('.scenes').not('#scene5').removeClass('active');
      } else {
        $('.scenes').removeClass('active');
      }
    };

    setTimeout(() => {
      $('.weddings-top__image').addClass('hiding');
      $('.wedding-vid').addClass('playing');
      $('#scene1').addClass('active');
      setTimeout(() => {
        headerVideo.play();
      }, 400);
      setInterval(() => {
        sceneChanger();
      }, 500);
    }, 5000);
  }

  const nextSlide = () => {
    const thisPanel = $('.dream-it-active');

    if ($('.twentytwenty-reveal').is(':visible')) {
      $('.twentytwenty-reveal').fadeOut('fast');
    }

    thisPanel.fadeOut(() => {
      thisPanel.removeClass('dream-it-active').promise().done((event) => {
        const nextPanel = $(event).parent('.twentytwenty-wrapper').next('.twentytwenty-wrapper').children('.dream-it-slider');

        if (nextPanel.length) {
          dreamItCounter++;
          if (dreamItCounter > inspirationSlider.inspirations.length) {
            dreamItCounter = inspirationSlider.inspirations.length;
          }

          nextPanel.trigger('slidein', 80).fadeIn(function() {
            $(this).addClass('dream-it-active');
            $('.blackBG').trigger('panelChange');
          });
        } else {
          dreamItCounter = 1;

          $('.twentytwenty-wrapper:first').children('.dream-it-slider').trigger('slidein', 80).fadeIn(function() {
            $(this).addClass('dream-it-active');
            $('.blackBG').trigger('panelChange');
          });
        }
      });
    });
  };

  const prevSlide = () => {
    const thisPanel = $('.dream-it-active');

    if ($('.twentytwenty-reveal').is(':visible')) {
      $('.twentytwenty-reveal').fadeOut('fast');
    }

    thisPanel.fadeOut(() => {
      thisPanel.removeClass('dream-it-active').promise().done(function() {
        const prevPanel = $(this).parent('.twentytwenty-wrapper').prev('.twentytwenty-wrapper').children('.dream-it-slider');

        if (prevPanel.length) {
          dreamItCounter--;
          if (dreamItCounter === 0) {
            dreamItCounter = 1;
          }
          prevPanel.trigger('slidein', 80).fadeIn(function() {
            $(this).addClass('dream-it-active');
            $('.blackBG').trigger('panelChange');
          });
        } else {
          dreamItCounter = $('.dream-it-slider').length;
          $('.twentytwenty-wrapper:last').children('.dream-it-slider').trigger('slidein', 80).fadeIn(function() {
            $(this).addClass('dream-it-active');
            $('.blackBG').trigger('panelChange');
          });
        }
      });
    });
  };

  $('.dream-it-nav i').click((e) => {
    if (e.target === document.querySelector('.slide-next')) {
      nextSlide();
    }
    if (e.target === document.querySelector('.slide-prev')) {
      prevSlide();
    }
  });


  $('.blackBG').on('panelChange', () => {
    const panelPos = $('.dream-it-active').index('.dream-it-slider') + 1;
    const activeIndexHeaderSlider = inspirationSlider.inspirations[panelPos - 1];

    $('.dream-it-caption .number').text(panelPos + '/' + $('.dream-it-slider').length);
    $('#inspirationTitle').text(activeIndexHeaderSlider.inspirationTitle);
    $('.dream-it-dots span.active').removeClass('active');
    $('.dream-it-dots span:nth-child(' + panelPos + ')').addClass('active');
  });

  $('.dream-it-dots span').click(function() {
    const panelPos = $(this).index('.dream-it-dots span');
    const thePanel = $('.dream-it-slider')[panelPos];
    const theDot = $(this);
    const activeIndexHeaderSlider = inspirationSlider.inspirations[panelPos];

    $('#inspirationTitle').text(activeIndexHeaderSlider.inspirationTitle);
    $('.dream-it-dots span.active').removeClass('active').promise().done(() => {
      theDot.addClass('active');
    });
    $('.dream-it-active').fadeOut(function() {
      $(this).removeClass('dream-it-active').promise().done(() => {
        $(thePanel).trigger('slidein', 80).fadeIn(function() {
          $(this).addClass('dream-it-active');
          $('.blackBG').trigger('panelChange');
        });
      });
    });
  });

  $('.twentytwenty-handle, .twentytwenty-bg').on('moveend', (event) => {
    let handle;

    if (event.target.nodeName === 'IMG') {
      handle = event.target.parentElement;
    } else {
      handle = event.target;
    }
    if (handle.offsetLeft + (handle.offsetWidth / 2) <= 150) {
      nextSlide();
    }
  });

};

dreamItSlider();

if (window.innerWidth < 768) {
  const boxSize = box.offsetHeight;
  const img = document.querySelector('#freeWeddingandCustomize .bg');
  const imgSize = (img.offsetHeight * 0.11);

  // debugger;

  boxContainer.style.marginBottom = `${boxSize - imgSize}px`;
}


const floatingBox = _globalUtils.debounce(() => {
  if (window.innerWidth < 768) {
    const boxSize = box.offsetHeight;
    const img = document.querySelector('#freeWeddingandCustomize .bg');
    const imgSize = (img.offsetHeight * 0.11);

    boxContainer.style.marginBottom = `${boxSize - imgSize}px`;
  } else {
    boxContainer.style.marginBottom = '';
  }
}, 300);

window.addEventListener('resize', floatingBox);
